import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import './QuoteFor.scss';

export default function QuoteFor(props) {
  return (
    <div className="quote-for" >
      <h3>
        <strong>
          <NumberFormat value={props.coverageAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        </strong>
        &nbsp;{props.separator && '- '} {props.productType}
      </h3>
    </div>
  );
}

QuoteFor.propTypes = {
  coverageAmount: PropTypes.number.isRequired,
  separator: PropTypes.bool,
  productType: PropTypes.string.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/Quoters/Common/QuoteFor/QuoteFor.js